/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LiveManagementCreateLivecarpRequest } from '../models/LiveManagementCreateLivecarpRequest';
import type { LiveManagementCreateLivecarpResponseApiRespoonse } from '../models/LiveManagementCreateLivecarpResponseApiRespoonse';
import type { LiveManagementDeleteLivecarpRequest } from '../models/LiveManagementDeleteLivecarpRequest';
import type { LiveManagementDeleteLivecarpResponseApiRespoonse } from '../models/LiveManagementDeleteLivecarpResponseApiRespoonse';
import type { LiveManagementEditLivecarpRequest } from '../models/LiveManagementEditLivecarpRequest';
import type { LiveManagementEditLivecarpResponseApiRespoonse } from '../models/LiveManagementEditLivecarpResponseApiRespoonse';
import type { LiveManagementExportZipRequest } from '../models/LiveManagementExportZipRequest';
import type { LiveManagementExportZipResponseApiRespoonse } from '../models/LiveManagementExportZipResponseApiRespoonse';
import type { LiveManagementGenerateZipCertRequest } from '../models/LiveManagementGenerateZipCertRequest';
import type { LiveManagementGenerateZipCertResponseApiRespoonse } from '../models/LiveManagementGenerateZipCertResponseApiRespoonse';
import type { LiveManagementGetTokenRequest } from '../models/LiveManagementGetTokenRequest';
import type { LiveManagementGetTokenResponseApiRespoonse } from '../models/LiveManagementGetTokenResponseApiRespoonse';
import type { LiveManagementListLivecarpForSelectRequest } from '../models/LiveManagementListLivecarpForSelectRequest';
import type { LiveManagementListLivecarpForSelectResponseApiRespoonse } from '../models/LiveManagementListLivecarpForSelectResponseApiRespoonse';
import type { LiveManagementListLivecarpRequest } from '../models/LiveManagementListLivecarpRequest';
import type { LiveManagementListLivecarpResponseApiRespoonse } from '../models/LiveManagementListLivecarpResponseApiRespoonse';
import type { LiveManagementReadLiveCsvRequest } from '../models/LiveManagementReadLiveCsvRequest';
import type { LiveManagementReadLiveCsvResponseApiRespoonse } from '../models/LiveManagementReadLiveCsvResponseApiRespoonse';
import type { LiveManagementViewLivecarpRequest } from '../models/LiveManagementViewLivecarpRequest';
import type { LiveManagementViewLivecarpResponseApiRespoonse } from '../models/LiveManagementViewLivecarpResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LiveManagementLiveService {

    /**
     * ライブ鯉一覧
     * @param requestBody
     * @returns LiveManagementListLivecarpResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminLive(
        requestBody: LiveManagementListLivecarpRequest,
    ): CancelablePromise<LiveManagementListLivecarpResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/live',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * list Livecarp for select box
     * @param requestBody
     * @returns LiveManagementListLivecarpForSelectResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminLiveListForSelect(
        requestBody: LiveManagementListLivecarpForSelectRequest,
    ): CancelablePromise<LiveManagementListLivecarpForSelectResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/live/list-for-select',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ライブ鯉の新規登録
     * @param requestBody
     * @returns LiveManagementCreateLivecarpResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminLiveCreate(
        requestBody: LiveManagementCreateLivecarpRequest,
    ): CancelablePromise<LiveManagementCreateLivecarpResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/live/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ライブ鯉の更新
     * @param requestBody
     * @returns LiveManagementEditLivecarpResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminLiveEdit(
        requestBody: LiveManagementEditLivecarpRequest,
    ): CancelablePromise<LiveManagementEditLivecarpResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/live/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ライブ鯉の削除
     * @param requestBody
     * @returns LiveManagementDeleteLivecarpResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminLiveDelete(
        requestBody: LiveManagementDeleteLivecarpRequest,
    ): CancelablePromise<LiveManagementDeleteLivecarpResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/live/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ライブ鯉ビュー
     * @param requestBody
     * @returns LiveManagementViewLivecarpResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminLiveView(
        requestBody: LiveManagementViewLivecarpRequest,
    ): CancelablePromise<LiveManagementViewLivecarpResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/live/view',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Process live csv
     * @param requestBody
     * @returns LiveManagementReadLiveCsvResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminLiveCsv(
        requestBody: LiveManagementReadLiveCsvRequest,
    ): CancelablePromise<LiveManagementReadLiveCsvResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/live/csv',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * ZIPファイルのダウンロード
     * @param requestBody
     * @returns LiveManagementExportZipResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminLiveExportZip(
        requestBody: LiveManagementExportZipRequest,
    ): CancelablePromise<LiveManagementExportZipResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/live/export-zip',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 証明書の生成
     * @param requestBody
     * @returns LiveManagementGenerateZipCertResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminLiveGenerateZipCert(
        requestBody: LiveManagementGenerateZipCertRequest,
    ): CancelablePromise<LiveManagementGenerateZipCertResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/live/generate-zip-cert',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * get token
     * @param requestBody
     * @returns LiveManagementGetTokenResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminLiveConnectSocketUrl(
        requestBody: LiveManagementGetTokenRequest,
    ): CancelablePromise<LiveManagementGetTokenResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/live/connect-socket-url',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
